// index.tsx

import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "@/App";
import "@/i18n/config";

const container = document.getElementById("root"); // Create a root.
if (!container) {
  throw new Error("Root container not found");
}
const root = ReactDOMClient.createRoot(container);

root.render(
  <BrowserRouter>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </BrowserRouter>,
);
